export default "__VITE_ASSET__CAfS9Z37__"